import { Model, Position, State } from 'src/types'
import { AGL_NE105_PRODUCT_NUMBER } from '../japan/constants/baseModel'

export const checkAtomsWeb2 = (webPartsValue: string, position: Position): boolean =>
  [
    'w6',
    'w8',
    'w9',
    'w10',
    'w11',
    'w13',
    'w14',
    'w17',
    'w19',
    'w20',
    'w23',
    'w25',
    'w27',
    'w28',
    'w29',
    'w30',
    'w31',
    'w32',
    'w33',
    'w34',
    'w36'
  ].includes(webPartsValue) ||
  (webPartsValue === 'w26' && position !== 'pitcher') ||
  position === 'first'

export const atomsYouthFilterLogic = (m: Model): boolean => m.series === 'youth'

export const isDefault_AGL_NE_105 = (productNumber: string, webPartsValue: string) => {
  return productNumber === AGL_NE105_PRODUCT_NUMBER && webPartsValue === 'unselected'
}
